import { isNil } from '@lucidlink/tscore';
import { CallStats, getPrintIndentation, StatsCommon } from '#common/stats';
export class FileStoreStats extends StatsCommon {
    blockStores;
    get;
    put;
    constructor(blockStores, log) {
        super();
        this.blockStores = blockStores;
        this.get = new CallStats('get', log);
        this.put = new CallStats('put', log);
    }
    toString(indentLevel) {
        let result = super.toString(indentLevel);
        const indentation = getPrintIndentation(indentLevel);
        for (const [_key, stats] of this.blockStores) {
            const blockStoreType = stats.constructor.name;
            result += `\n${indentation}${blockStoreType}:`;
            result += stats.toString(!isNil(indentLevel) ? indentLevel + 1 : undefined);
        }
        return result;
    }
}
